import { render, staticRenderFns } from "./IndexService.vue?vue&type=template&id=1fb73009&scoped=true"
import script from "./IndexService.vue?vue&type=script&lang=js"
export * from "./IndexService.vue?vue&type=script&lang=js"
import style0 from "./IndexService.vue?vue&type=style&index=0&id=1fb73009&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb73009",
  null
  
)

export default component.exports